module.exports = __webpack_public_path__ + "static/media/hisopados_cross.4bb860a6.svg";